import { UserPlan } from "@common/api/billingService";

// Mapping for expired plans: <planCode, planName>
const EXPIRED_PLAN_NAME_MAP: Record<string, string> = {
    'BASIC': 'Basic Expired',
    'FREE': 'Trial Expired',
};

export const getPlanName = (plan: UserPlan | null) => {
    // Handle undefined plan
    if (!plan) {
        return '';
    }

    // Check if plan is expired
    const isExpired = new Date(plan.endAt) < new Date();

    if (isExpired) {
        // Return mapped name for expired plans
        return EXPIRED_PLAN_NAME_MAP[plan.planCode] || 'Plan Expired';
    }

    return plan.planName
}